import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceTable from '@app/components/apps/PreClearance/PreClearanceTable';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';

const AllPreClearance: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userType = user?.usertype;

  function handleCreateClick(): void {
    navigate('/add-pre-clearance');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/pre-clearance',
            breadcrumbName: 'Pre-Clearance',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    if (userType !== 'ADMIN') {
      addHeaderButton(
        'Add Pre Clearance',
        <BaseButton type="primary" size="small" onClick={handleCreateClick}>
          Add Pre-Clearance
        </BaseButton>,
      );
    }
    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Pre-Clearance</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPreClearance;
